'use strict';

(function () {

  'use strict';

  angular.module('specsguardApp')
    .factory('statusInterceptor', statusInterceptor);

  statusInterceptor.$inject = ['$rootScope', '$q', '$state', '$log'];

  function statusInterceptor ($rootScope, $q, $state, $log) {

    return {
      request: function (config) {
        if (config.method !== 'GET') {
          $rootScope.httpStatus = 'saving';
        }

        return config;
      },

      response: function (response) {
        if (response.config.method !== 'GET') {
          $rootScope.httpStatus = 'done';
        }

        if ( angular.isDefined(response.data.status) && angular.isDefined(response.data.data) ) {
          if (response.data.status === 'success') {
            response.data = response.data.data;
          }
        } else if (angular.isDefined(response.data.status) && angular.isDefined(response.data.error)) {
          $rootScope.$emit('showWarning', response.data.error.msg);
          $state.go('login');
        }
        return response;
      },

      responseError: function (response) {
        $rootScope.httpStatus = 'error';

        if (response.status === 401) {
          $state.go('logout');
          $rootScope.$emit('showError', response.data.error.msg);
        } else if (response.status === 403) {
          $rootScope.$emit('showWarning', response.data.error.msg);
          $state.go('login');
        } else if (response.status >= 500 && response.status <= 599) {
          $rootScope.httpErrorMessage = response.data;
          $log.error('BACK-END ERROR: ', response.data, response);
          $rootScope.$emit('showWarning', response.data.error ? response.data.error.msg : 'Probleem met back-end');
        } else {
          $rootScope.$emit('showWarning', response.data ? response.data.error.msg : 'Er is iets misgegaan');
        }

        response.error = response.data ? response.data.error : 'Onbekend probleem';

        // Always reject (or resolve) the deferred you're given
        return $q.reject(response);
      }
    };
  }

})();

